(function () {
"use strict";
// packages/html-entities/src/index.ts
var $dda22c0315f072ca$var$_decodeTextArea;
function $dda22c0315f072ca$export$6cb344a21ca18aec(html) {
    if ("string" !== typeof html || -1 === html.indexOf("&")) return html;
    if (void 0 === $dda22c0315f072ca$var$_decodeTextArea) {
        if (document.implementation && document.implementation.createHTMLDocument) $dda22c0315f072ca$var$_decodeTextArea = document.implementation.createHTMLDocument("").createElement("textarea");
        else $dda22c0315f072ca$var$_decodeTextArea = document.createElement("textarea");
    }
    $dda22c0315f072ca$var$_decodeTextArea.innerHTML = html;
    const decoded = $dda22c0315f072ca$var$_decodeTextArea.textContent ?? "";
    $dda22c0315f072ca$var$_decodeTextArea.innerHTML = "";
    return decoded;
}


const $e941d9a459693ae0$var$React = window.React;
const { useState: $e941d9a459693ae0$var$useState, useEffect: $e941d9a459693ae0$var$useEffect, useRef: $e941d9a459693ae0$var$useRef } = $e941d9a459693ae0$var$React;
const { createRoot: $e941d9a459693ae0$var$createRoot } = window.ReactDOM.client;
const $e941d9a459693ae0$var$defaultPostTypesToSearch = [
    {
        label: 'Articles',
        value: 'post'
    },
    {
        label: 'Pages',
        value: 'page'
    }
];
function $e941d9a459693ae0$var$initSearchPage() {
    const elSearchResults = document.getElementById('search-results');
    const postSlugsAndLabels = elSearchResults?.dataset?.searchSettingsPostTypes ? JSON.parse(elSearchResults.dataset.searchSettingsPostTypes) : {};
    const root = $e941d9a459693ae0$var$createRoot(elSearchResults);
    let postTypesToSearch = Object.keys(postSlugsAndLabels)?.length > 0 ? Object.keys(postSlugsAndLabels).map((key)=>({
            label: postSlugsAndLabels[key].searchLabel,
            value: key
        })) : $e941d9a459693ae0$var$defaultPostTypesToSearch;
    // Filter if enabled is false
    postTypesToSearch = postTypesToSearch.filter((pt)=>postSlugsAndLabels[pt.value]?.enabled === true);
    let defaultPage = 1;
    const urlParams = new URLSearchParams(window.location.search);
    // Default page from /page/num or query param ?page=num
    const pageParam = urlParams.get('page');
    const path = window.location.pathname;
    const pageMatchesFromPath = path.match(/\/page\/(\d+)/);
    if (pageParam) defaultPage = parseInt(pageParam, 10);
    else if (pageMatchesFromPath) defaultPage = parseInt(pageMatchesFromPath[1], 10);
    // Get ?s param value
    const searchParam = urlParams.get('s');
    root.render(/*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$SearchApp, {
        query: searchParam || '',
        page: defaultPage || 1,
        postTypesToSearch: postTypesToSearch
    }));
}
document.addEventListener("DOMContentLoaded", function() {
    $e941d9a459693ae0$var$initSearchPage();
});
const $e941d9a459693ae0$var$listItemClasses = "px-md-2 px-3 mx-n3 px-lg-3 mx-lg-n3 py-3 py-lg-3 rounded-4";
const $e941d9a459693ae0$var$ulClasses = "mx-0 my-4 my-lg-4 list-unstyled";
function $e941d9a459693ae0$var$SearchApp({ query: initialQuery, page: initialPage, postTypesToSearch: postTypesToSearch }) {
    const [query, setQuery] = $e941d9a459693ae0$var$useState(initialQuery);
    const [results, setResults] = $e941d9a459693ae0$var$useState([]);
    const [loading, setLoading] = $e941d9a459693ae0$var$useState(false);
    const [totalPages, setTotalPages] = $e941d9a459693ae0$var$useState(0);
    const [currentPage, setCurrentPage] = $e941d9a459693ae0$var$useState(parseInt(initialPage, 10));
    const [totalResults, setTotalResults] = $e941d9a459693ae0$var$useState(0);
    const [postTypes, setPostTypes] = $e941d9a459693ae0$var$useState(postTypesToSearch);
    const [hasSearched, setHasSearched] = $e941d9a459693ae0$var$useState(initialQuery?.length >= 3);
    const [useFilters, setUseFilters] = $e941d9a459693ae0$var$useState(false);
    const [sortBy, setSortBy] = $e941d9a459693ae0$var$useState('recent'); // 'relevance' or 'recent'
    const hasAnime = typeof anime === 'function';
    const listRef = $e941d9a459693ae0$var$useRef(null);
    const getPostTypesString = (postTypes)=>{
        return postTypes.reduce((acc, pt)=>acc + pt.value + ',', '').slice(0, -1);
    };
    // Update query when input changes
    $e941d9a459693ae0$var$useEffect(()=>{
        const elSearchInput = document.getElementById('search-input');
        function handleInput(event) {
            setQuery(event.target.value?.trim?.());
            setCurrentPage(1);
            setTotalPages(0);
            setTotalResults(0);
        }
        elSearchInput.addEventListener('input', handleInput);
        return ()=>{
            elSearchInput.removeEventListener('input', handleInput);
        };
    }, []);
    $e941d9a459693ae0$var$useEffect(()=>{
        if (query.length < 3) {
            setResults([]);
            return;
        }
        setHasSearched(true);
        setLoading(true);
        const abortController = new AbortController();
        const debounceTimeout = setTimeout(()=>{
            const sortParam = sortBy === 'recent' ? '&sort_by=recent' : '';
            fetch(`/wp-json/adw/v1/search-adw?search=${encodeURIComponent(query)}&type=post&subtype=${getPostTypesString(postTypes)}&per_page=10&page=${currentPage}${sortParam}`, {
                signal: abortController.signal
            }).then((response)=>{
                const totalPagesHeader = response.headers.get('X-WP-TotalPages');
                if (totalPagesHeader) setTotalPages(parseInt(totalPagesHeader, 10));
                const totalResultsHeader = response.headers.get('X-WP-Total');
                if (totalResultsHeader) setTotalResults(parseInt(totalResultsHeader, 10));
                return response.json();
            }).then((data)=>{
                setResults(data);
                setLoading(false);
            }).catch((error)=>{
                if (error.name !== 'AbortError') {
                    console.error('Search error:', error);
                    setLoading(false);
                }
            });
        }, 300);
        return ()=>{
            clearTimeout(debounceTimeout);
            abortController.abort();
        };
    }, [
        query,
        currentPage,
        postTypes,
        sortBy
    ]);
    $e941d9a459693ae0$var$useEffect(()=>{
        if (!useFilters) setPostTypes(postTypesToSearch);
    }, [
        useFilters
    ]);
    $e941d9a459693ae0$var$useEffect(()=>{
        if (hasAnime) // Stagger results fade-in
        anime({
            targets: listRef.current?.children,
            opacity: [
                0,
                1
            ],
            translateY: [
                5,
                0
            ],
            delay: anime.stagger(30),
            duration: 500,
            easing: 'easeOutQuad'
        });
    }, [
        results
    ]);
    // Update URL without reloading the page
    $e941d9a459693ae0$var$useEffect(()=>{
        const url = new URL(window.location);
        url.searchParams.set('s', query);
        if (currentPage > 1) url.searchParams.set('page', currentPage);
        else url.searchParams.delete('page');
        window.history.replaceState({}, '', url);
    }, [
        query,
        currentPage
    ]);
    const Filters = ()=>{
        return /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$React.Fragment, null, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "d-flex flex-row flex-wrap justify-content-center justify-content-lg-end gap-3 row-gap-2 mt-3"
        }, postTypesToSearch.map((postType)=>/*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
                key: postType.value,
                className: "form-check "
            }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("input", {
                className: "form-check-input mb-0",
                type: "checkbox",
                disabled: postTypes.length === 1 && postTypes.some((pt)=>pt.value === postType.value),
                id: `filter-${postType.value}`,
                checked: postTypes.some((pt)=>pt.value === postType.value),
                onChange: (e)=>{
                    if (e.target.checked) setPostTypes([
                        ...postTypes,
                        postType
                    ]);
                    else // If last one is unchecked, check all
                    if (postTypes.length === 1) setPostTypes(postTypesToSearch);
                    else setPostTypes(postTypes.filter((pt)=>pt.value !== postType.value));
                    setCurrentPage(1);
                }
            }), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("label", {
                className: "form-check-label",
                htmlFor: `filter-${postType.value}`
            }, postType.label)))));
    };
    const PostTypeBadge = ({ postType: postType })=>{
        let badgeLabel = '';
        if (postType?.includes('event')) badgeLabel = 'Event';
        else if (postType?.includes('adw_podcast_show')) badgeLabel = 'Podcast';
        else if (postType?.includes('adw_resource')) badgeLabel = 'Resource';
        else if (postType?.includes('webinar')) badgeLabel = 'Webinar';
        return badgeLabel ? /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "d-none d-lg-block border border-primary text-primary rounded-2 fs-7 py-1 px-2 text-uppercase"
        }, badgeLabel) : null;
    };
    return /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$React.Fragment, null, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
        className: "d-flex flex-column flex-lg-row row-gap-3 justify-content-between align-items-center mt-3 "
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("p", {
        className: "mb-0 fs-7 opacity-75"
    }, totalResults && totalResults > 0 ? /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$React.Fragment, null, "Found ", /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
        className: "fw-bold"
    }, totalResults.toLocaleString()), " results.") : /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$React.Fragment, null, !loading && hasSearched && 'No results found. ', query?.length < 3 && 'Enter at least three characters.', /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$React.Fragment, null, "\xA0"))), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
        className: "d-flex align-items-center gap-3"
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
        className: "d-flex align-items-center gap-2"
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
        className: "fs-7"
    }, "Sort By"), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("select", {
        className: "form-select form-select-sm",
        value: sortBy,
        onChange: (e)=>{
            setSortBy(e.target.value);
            setCurrentPage(1);
        },
        style: {
            width: 'auto',
            minWidth: '120px'
        }
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("option", {
        value: "relevance"
    }, "Relevance"), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("option", {
        value: "recent"
    }, "Recent"))), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
        className: "d-flex align-items-center gap-1 "
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("input", {
        id: "search-filter-toggle",
        checked: useFilters,
        onChange: ()=>setUseFilters(!useFilters),
        className: `d-none tgl tgl-light control control-length mixitup-control-${useFilters ? 'active' : 'inactive'}`,
        type: "checkbox"
    }), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("label", {
        className: "tgl-btn mb-0",
        htmlFor: "search-filter-toggle",
        style: {
            transform: 'scale( 0.8 )'
        }
    }), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
        className: "fs-7"
    }, "Filter")))), useFilters && /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement(Filters, null), results?.length > 0 && !loading ? /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$React.Fragment, null, loading && /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$PlaceholderPostList, null), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("ul", {
        ref: listRef,
        className: $e941d9a459693ae0$var$ulClasses
    }, results.map((result)=>/*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("li", {
            key: result.id,
            className: `${$e941d9a459693ae0$var$listItemClasses} `,
            style: {
                opacity: hasAnime ? 0 : 1
            }
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("a", {
            className: " text-decoration-none row d-flex align-items-center ",
            href: result.url
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "col-lg-3",
            style: {
                maxWidth: '90px'
            }
        }, result?.thumbnail?.thumbnail ? /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("img", {
            src: result.thumbnail.thumbnail,
            alt: (0, $dda22c0315f072ca$export$6cb344a21ca18aec)(result.thumbnail.alt),
            className: "w-100 rounded-3",
            style: {
                aspectRatio: '1/1',
                objectFit: 'cover',
                backgroundColor: '#bebebeff'
            }
        }) : /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("img", {
            src: "/wp-content/themes/adweek-next/src/images/logos/adweek-square-mark-black.svg",
            alt: "Adweek",
            className: "w-100 rounded-3",
            style: {
                aspectRatio: '1/1',
                objectFit: 'cover',
                backgroundColor: '#c1c1c1ff'
            }
        })), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "col d-flex ps-0 ps-md-3 align-items-center gap-4"
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement(PostTypeBadge, {
            postType: result.subtype
        }), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "d-flex flex-column gap-2"
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "d-inline-flex gap-3 justify-content-start align-items-baseline"
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("h3", {
            className: " font-primary h5 mb-0"
        }, result?.is_exclusive && /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
            className: "article-label font-pre-heading fs-8 text-uppercase rounded-end-top-3 rounded-start-bottom-3"
        }, "Exclusive"), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: (0, $dda22c0315f072ca$export$6cb344a21ca18aec)(result.title)
            }
        }))), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "d-flex gap-3 align-items-baseline"
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
            className: "fs-7 d-none d-lg-block "
        }, result?.date_formatted?.length > 0 ? result.date_formatted : ''))))))))) : loading && /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$PlaceholderPostList, null), results && results.length > 0 && /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement($e941d9a459693ae0$var$Pagination, {
        currentPage: currentPage,
        totalPages: totalPages,
        onPageChange: (page)=>setCurrentPage(page)
    }));
}
function $e941d9a459693ae0$var$Pagination({ currentPage: currentPage, totalPages: totalPages, onPageChange: onPageChange }) {
    if (totalPages <= 1) return null;
    const additionalPagesToShow = 0;
    // Calculate the range of pages to show (5 before and 5 after current page)
    const startPage = Math.max(1, currentPage - additionalPagesToShow);
    const endPage = Math.min(totalPages, currentPage + additionalPagesToShow);
    const pages = [];
    for(let i = startPage; i <= endPage; i++)pages.push(i);
    const pageClass = 'btn btn-sm btn-outline-primary';
    return /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
        className: "pagination d-flex align-items-stretch justify-content-center gap-2"
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("button", {
        disabled: currentPage === 1,
        onClick: ()=>onPageChange(currentPage - 1),
        "aria-label": "Previous page",
        className: "btn btn-sm btn-outline-primary"
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24px",
        viewBox: "0 -960 960 960",
        width: "24px",
        fill: "currentColor"
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("path", {
        d: "M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"
    }))), pages.map((page)=>/*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("button", {
            key: page,
            onClick: ()=>onPageChange(page),
            style: {
                transition: 'all 0.3s easeOut',
                minWidth: '5ch'
            },
            className: `${page === currentPage ? 'btn btn-primary btn-sm text-white ' : pageClass}`
        }, page)), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("button", {
        disabled: currentPage === totalPages,
        onClick: ()=>onPageChange(currentPage + 1),
        "aria-label": "Next page",
        className: "btn btn-sm btn-outline-primary"
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24px",
        viewBox: "0 -960 960 960",
        width: "24px",
        fill: "currentColor"
    }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("path", {
        d: "M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"
    }))));
}
function $e941d9a459693ae0$var$PlaceholderPostList() {
    const placeholders = Array.from({
        length: 10
    });
    return /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("ul", {
        className: $e941d9a459693ae0$var$ulClasses,
        "aria-hidden": "true"
    }, placeholders.map((_, index)=>/*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("li", {
            key: index,
            className: $e941d9a459693ae0$var$listItemClasses
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "row d-flex align-items-center mb-0"
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "col-lg-3",
            style: {
                maxWidth: '90px'
            }
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "placeholder rounded-3",
            style: {
                width: '100%',
                aspectRatio: '1/1'
            }
        })), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("div", {
            className: "col ps-0 ps-md-3 gap-3 d-flex flex-column"
        }, /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
            className: "placeholder col-10"
        }), /*#__PURE__*/ $e941d9a459693ae0$var$React.createElement("span", {
            className: "placeholder col-3"
        }))))));
}

})();
//# sourceMappingURL=index.js.map
